import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_add",
  "use": "micro_add-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_add\"><path fill-rule=\"evenodd\" d=\"M5 0H4v4H0v1h4v4h1V5h4V4H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol